import styled from 'styled-components'

import { rspTheme } from '../../styles/rspTheme'

export const JumpLinksContainer = styled.ul`
  max-width: 239px;
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
  display: flex;
  flex-direction: column;

  @media (max-width: ${rspTheme.breakpoints.values.sm}px) {
    max-width: unset;
  }
`

export const JumpLink = styled.li`
  margin-block-end: 40px;
  padding-inline-start: 24px;
  position: relative;

  &:not(:last-of-type)::after {
    content: '';
    position: absolute;
    left: 6px;
    top: 6px;
    display: block;
    width: 1px;
    height: calc(100% + 46px);
    border-left: 1px solid ${rspTheme.palette.primary.main};
  }

  a {
    font-size: 1.8rem;
    font-weight: 300;
    line-height: 1.33;
    letter-spacing: 0.15px;
    color: ${rspTheme.palette.primary.main};
    text-decoration-color: transparent;
    transition: text-decoration-color 0.2s ease-in-out;

    .indicatorDot {
      position: absolute;
      left: 0;
      top: 4px;
      width: 12px;
      height: 12px;
      transition: all 0.2s ease-in-out;
      transform-origin: center;
      transform: scale(1);
      z-index: 10;

      circle {
        fill: ${rspTheme.palette.primary.main};
        transition: fill 0.2s ease-in-out;
      }

      &.active {
        transform: scale(1.33);
        circle {
          fill: ${rspTheme.palette.secondary.main};
        }
      }
    }

    &:hover,
    &:focus {
      text-decoration-color: inherit;

      circle {
        fill: ${rspTheme.palette.secondary.main};
      }
    }
  }
`
